
import AppHeader from '@/components/Header.vue'
import DeviceFooter from '@/components/device/Footer.vue'
import { defineComponent, ref, getCurrentInstance, onMounted, reactive, onBeforeUnmount } from 'vue'
import { VectorLayer, Marker, Coordinate } from 'maptalks'
import { getServiceNetWork } from '@/apis/service'
import getMapSiteInfo from '@/compositions/map/index'
import { getMap } from '@/utils/maptalkFactory'
import { Search, RadioGroup, Radio, List, Toast } from 'vant'
import { changeServiceNetWork } from '@/apis/service'
import { useStore } from 'vuex'
const __default__ = defineComponent({
  name: 'RepairOrder',
  components: {
    AppHeader,
    vanSearch: Search,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    vanList: List,
    DeviceFooter,
  },
  setup() {
    let listLoading = ref(false) // 列表加载标志
    let listFinished = ref(false) // 数据加载完成标志
    let searchValue = ref('') // 搜索关键字
    let selectAddress = ref(null) // 当前选择的地址
    let addressList = ref([]) // 地址列表
    let layer: VectorLayer = null // 图层
    let searchLoading = ref(false)
    const { proxy } = getCurrentInstance() // 实例对象
    let paginaData = reactive({
      page: 1,
      size: 10,
      total: 0,
    })
    let map: any = null
    const store = useStore() // vuestore
    let { mapSite, mapZoom, mapCenter } = getMapSiteInfo()

    const getNetWork = async () => {
      let param = {
        lng: mapCenter.value[0],
        lat: mapCenter.value[1],
        keywords: searchValue.value,
        page: paginaData.page,
        per_page: paginaData.size,
        is_only_own: 1,
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await getServiceNetWork(param)
        toast.clear()
        if (paginaData.page == 1) {
          addressList.value = result.data
          paginaData.total = result.total
        }
        if (paginaData.page > 1) {
          for (let i = 0; i < result.data.length; i++) {
            addressList.value.push(result.data[i])
            paginaData.total = result.total
          }
        }
        if (addressList.value.length >= result.total) {
          listFinished.value = true
        }
        listLoading.value = false
      } catch (error) {
        toast.clear()
        Toast('获取网点信息失败,请刷新重试!')
        console.log(error)
      }
    }
    const listOnLoad = () => {
      getNetWork()
      paginaData.page++
    }
    const calculDistance = (distance: number) => {
      if (distance > 1000) {
        return (distance / 1000).toFixed(2) + 'km'
      }
      if (distance <= 1000) {
        return distance.toFixed(2) + 'm'
      }
    }
    const handleChangeAddress = () => {
      layer?.clear()
      let point = [selectAddress.value.lng, selectAddress.value.lat]
      const marker: Marker = new Marker(point, {
        id: Date.now().toString(),
        editable: false,
        interactive: false,
        symbol: {
          markerFile: '/images/icon_weizhi.png',
          markerWidth: 40,
          markerHeight: 40,
          scale: 1,
          textName: selectAddress.value.name,
          textFill: 'rgba(255,255,255,1)',
          textSize: 12,
          textWeight: 500,
          textHaloFill: '#222',
          textHaloRadius: 1,
          textHaloOpacity: 0.6,
        },
      })
      layer?.addGeometry(marker)
      map.setCenter(new Coordinate(point))
    }
    const handleRightClick = async () => {
      if (!selectAddress.value) {
        Toast('请选择维修网点')
        return
      }
      let query = {
        warehouse_guid: selectAddress.value.guid,
        warehouse_type: selectAddress.value.type,
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result = await changeServiceNetWork(proxy.$route.params.guid as string, query)
        toast.clear()
        Toast('修改成功')
        setTimeout(() => {
          proxy.$router.replace({ path: `/servicedetail/${proxy.$route.params.guid}` })
        }, 1000)
      } catch (error: any) {
        let message = error && error.message ? error.message : '修改网点失败'
        toast.clear()
        Toast(message)
      }
    }
    const handleSearch = () => {
      if (!searchLoading.value) {
        paginaData.page = 1
        searchLoading.value = true
        setTimeout(async () => {
          await getNetWork()
          searchLoading.value = false
        }, 2000)
      }
    }
    const handleBack = () => {
      proxy.$router.replace({ path: `/servicedetail/${proxy.$route.params.guid}` })
    }
    onBeforeUnmount(() => {
      map.remove()
    })
    // 相当于原来的mounted
    onMounted(async () => {
      map = getMap(document.getElementById('service-map-box'), {
        center: mapCenter.value,
        zoom: mapZoom.value,
        attribution: false,
      })
      layer = new VectorLayer(Date.now().toString()).addTo(map)
      const pageEl = document.getElementById('reserve-page')
      const pagePaddingBottom = store.getters.isMiniProgram ? 50 : 0
      const pagePaddingTop = store.getters.pagePaddingTop
      pageEl?.style.setProperty('--bottom', `${pagePaddingBottom}px`)
      pageEl?.style.setProperty('--top', `${pagePaddingTop}px`)
    })

    return {
      addressList,
      listLoading,
      listFinished,
      selectAddress,
      searchValue,
      isMiniProgram: store.getters.isMiniProgram,
      pagePaddingTop: store.getters.pagePaddingTop,
      pagePaddingBottom: store.getters.isMiniProgram ? 50 : 0,
      map,
      handleChangeAddress,
      calculDistance,
      listOnLoad,
      handleRightClick,
      handleSearch,
      handleBack,
    }
  },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "64904d7d": (_ctx.pagePaddingTop + 'px'),
  "1f2671fd": (_ctx.pagePaddingBottom + 'px')
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__